import { Box, Skeleton } from '@mui/material';
import React from 'react';

interface CategoryAccordionSkeletonProps {
  hasActions: boolean;
}

const CategoryAccordionSkeleton: React.FC<CategoryAccordionSkeletonProps> = ({ hasActions }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      padding: 2,
      borderRadius: '4px',
      border: '1px solid #ddd',
      gap: 2,
    }}
  >
    <Box
      sx={{
        width: 0,
        height: 0,
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent',
        borderLeft: (theme) =>
          `15px solid ${
            theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.11)' : 'rgba(255, 255, 255, 0.13)'
          }`,
        animation: 'pulseTriangle 1.5s ease-in-out infinite',
        '@keyframes pulseTriangle': {
          '0%': { opacity: 1 },
          '50%': { opacity: 0.4 },
          '100%': { opacity: 1 },
        },
      }}
    />
    <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
      <Skeleton variant="text" width="90%" height={30} />
      {/* Quantity of questions */}
      <Skeleton variant="text" width="30%" height={20} />
    </Box>
    {/* New Question */}
    {hasActions && <Skeleton variant="circular" width={35} height={35} />}
    {/* Spacer */}
    <Box sx={{ flexGrow: 2 }}></Box>
    {/* Actions */}
    {hasActions && (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {Array.from({ length: 1 }).map((_, i) => (
          <Skeleton key={i} variant="circular" width={35} height={35} />
        ))}
      </Box>
    )}
  </Box>
);

export default CategoryAccordionSkeleton;
